// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-authentication-modal .el-dialog__body {\n  padding: 30px 20px 0;\n}\n.user-authentication-modal .el-input--medium .el-input__inner {\n  height: 45px;\n  line-height: 45px;\n}", ""]);
// Exports
module.exports = exports;
